import { ChangeDetectorRef, Component, inject, OnInit, signal } from '@angular/core';
import { Appointment } from '@shared/entities/appointment';
import { BoardService } from '../../board.service';
import { FileService } from '@shared/_services/file.service';
import { DatePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-board-next-appointment',
  templateUrl: 'next-appointment.component.html',
  imports: [
    MatIcon,
    MatButton,
    MatTooltip,
    DatePipe,
    TranslateModule,
  ],
})
export class NextAppointmentComponent implements OnInit {
  private boardService = inject(BoardService);
  private fileService = inject(FileService);
  private cdr = inject(ChangeDetectorRef);

  public appointment = signal<Appointment | null>(null);
  public noAppointment = signal<boolean>(false);
  public loading = signal<boolean>(true);

  ngOnInit(): void {
    this.boardService.getNextBoardAppointment().subscribe(appointment => {
      if (appointment && appointment.id) {
        if (appointment.date) {
          appointment.date = appointment.date.slice(0, 10);
        }
        this.appointment.set(appointment);
        this.noAppointment.set(false);
        this.loading.set(false);
      } else {
        this.noAppointment.set(true);
        this.loading.set(false);
      }
      this.cdr.detectChanges();
    });
  }

  public getWeekday(nr: string): string {
    return this.boardService.getWeekday(nr);
  }

  public deliverFile(code: string, fileType: string, filename: string): void {
    this.fileService.deliverFile(code, fileType, filename);
  }
}
